import React, { Fragment } from 'react';
import RichTextEditor from 'legacy/src/components/content/editor/types/shared/RichTextEditor';
import Button from 'chameleon/ui-stack/ui/base/button';

const EditScoringCriterias = ({
  criteriaIndex,
  criteriaCursor,
  showAddCriteriaButton,
  handleRemoveScoringCriteria,
  handleAddScoringCriteria,
  criteriaValidation,
}) => (
  <Fragment>
    {criteriaIndex === 0 ? (
      <h4 className="label-column">Scoring Criteria</h4>
    ) : (
      <div className="label-column" />
    )}
    <div className="content-column">
      <RichTextEditor
        data-test-criteria
        valueLink={criteriaCursor}
        hasError={criteriaValidation}
      />
    </div>
    {criteriaValidation && (
      <div className="action-column error-message --offset">
        {criteriaValidation}
      </div>
    )}
    <br />
    <div className="action-column mb-10">
      {showAddCriteriaButton ? (
        <Button
          isPrimary
          onClick={handleAddScoringCriteria}
          className="mr-4 ScoreCategoryEditor__add_criteria"
        >
          Add Checkbox
        </Button>
      ) : null}
      <Button
        isOutline
        className="ScoreCategoryEditor__remove_criteria"
        onClick={() => handleRemoveScoringCriteria(criteriaIndex)}
      >
        Remove Checkbox
      </Button>
    </div>
  </Fragment>
);

export default EditScoringCriterias;
